<template>
  <v-hover v-slot:default="{ hover }">
    <div>
      <v-row no-gutters>
        <v-col cols="1">
          <v-icon x-large>mdi-account-circle</v-icon>
        </v-col>
        <v-col cols="11">
          <v-row no-gutters>
            <h4>{{comment.autor}}</h4>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon icon color="primary" v-on="on" @click="edit" v-if="canEdit">mdi-pencil</v-icon>
              </template>
              <span>{{$t('Edit')}}</span>
            </v-tooltip>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon icon color="red" v-on="on" @click="remove" v-if="canDelete">mdi-delete</v-icon>
              </template>
              <span>{{$t('Delete')}}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-badge overlap bordered>
                  <template v-slot:badge>
                    <span v-on="on">{{comment.pageNumber}}</span>
                  </template>
                  <v-icon v-on="on">mdi-bookmark</v-icon>
                </v-badge>
              </template>
              <span class="ml-2">{{$t('Page')}}</span>
            </v-tooltip>

            <span class="ml-2">{{comment.date}}</span>
          </v-row>
          <v-row no-gutters>
            <div v-html="comment.text" />
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-2"></v-divider>
    </div>
  </v-hover>
</template>
<script>
import Utils from "@/ecm/common/Utils";
export default {
  props: {
    comment: {
      type: Object
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    edit() {
      this.$emit("on-edit-comment", Utils.object.toJS(this.comment));
    },
    remove() {
      this.$emit("on-remove-comment", this.comment.id);
    }
  }
};
</script>